var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMicrosoft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15.206v15.206H0z",
    fill: "#f25022"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.794 0H32v15.206H16.794z",
    fill: "#7fba00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.794h15.206V32H0z",
    fill: "#00a4ef"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.794 16.794H32V32H16.794z",
    fill: "#ffb900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMicrosoft);
export default __webpack_public_path__ + "static/1775031319/media/icon-microsoft.45958f98a37d115aea97c26b60a6abc5.svg";
export { ForwardRef as ReactComponent };